




import { VOZIDLO_RIDIC } from '@/modules/kartoteka/partner/constants';

import { BaseSelect, selectName } from '#components/baseSelect';

export default BaseSelect.extend({
	name: selectName(VOZIDLO_RIDIC),
	props: {
		filter: { type: Object, default: () => {} },
	},
	data() {
		return {
			storeObject: VOZIDLO_RIDIC,
			emptyObject: {
				jmeno: null,
				prijmeni: null,
				telefon: null,
				email: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: any) {
			return {
				jmeno: data.JMENO,
				prijmeni: data.PRIJMENI,
				telefon: data.TEL_NR,
				email: data.E_MAIL_ADRESA,
			};
		},
	},
});
